import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

interface CreditCard {
    id: string;
    type: 'mastercard' | 'visa';
    lastFourDigits: string;
    expiryDate: string;
    logoPath: string;
}

@Component({
    selector: 'gl-remove-credit-card-modal',
    templateUrl: './remove-credit-card-modal.component.html',
    styleUrls: ['./remove-credit-card-modal.component.scss']
})
export class RemoveCreditCardModalComponent {
    @Input() card!: CreditCard;

    constructor(private modalCtrl: ModalController) {}

    dismiss() {
        this.modalCtrl.dismiss({ confirmed: false });
    }

    confirm() {
        this.modalCtrl.dismiss({ confirmed: true });
    }
}
